import { render, staticRenderFns } from "./NumberLoader.vue?vue&type=template&id=887d053e&scoped=true&"
import script from "./NumberLoader.vue?vue&type=script&lang=js&"
export * from "./NumberLoader.vue?vue&type=script&lang=js&"
import style0 from "./NumberLoader.vue?vue&type=style&index=0&id=887d053e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887d053e",
  null
  
)

export default component.exports